import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import {NatGetRoomToResidentAuthenticationKey} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import {NatGetToken} from '../token/repository/NatGetToken'
import {
    AGREEMENT_TYPE,
    DO_OR_NOT,
    FIRST_LOGIN_REFERRER_ID,
    RESIDENT_USER_TYPE,
    SEX_MASTER,
    VALID_OR_NOT,
} from '../../../CodeMaster'
import {
    autoKanaOnUpdate,
    convertToRoomNumberForResident,
    getCurrentYear,
    getQueryParameter,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatResidentUserRepo, {ResidentUserConfirmRequest} from '../residentUser/repository/NatResidentUserRepo'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    Note,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    DisplayBlockDiv,
    DisplayCheckItemSelectionLabel,
    DisplayCheckItemSelectionName,
    DisplayItemDiv,
    DisplayItemInput,
    DisplayItemInputLabel,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    DisplayItemSelect,
    DisplayItemSelectIcon,
    DisplayRadioItemLabel,
    DisplayRadioItemName,
    FieldErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors, FontSize} from '../../../styledComponents/Constants'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {Box, Checkbox} from '@mui/material'
import {Messages} from '../../../Messages'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {OptionProps} from '../../../components/shared/forms/PPSelect'
import {NatPostResidentUserConfirm} from '../residentUser/repository/NatPostResidentUserConfirm'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import {NatOwnershipTransfersRepo} from '../ownershipTransfers/repository/NatOwnershipTransfersRepo'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'


interface FirstLoginLocationState {
    firstLoginReferrerId: string
    policyAgreeType: string
    authenticationKey: string
    residentUserType: string
    firstLoginUserInfoInput: {
        parentResidentId: string,
        residentUserType: string,
        condominiumCd: string
        condominiumName: string,
        ridgeName: string,
        roomNumber: string,
        policyAgreeType: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        mailAddress: string,
        birthday: string,
        sex: string,
        password: string,
        wishToHasekoGroupInfos: string,
        wishToHasekoGroupInfosDispFlg: boolean,
        sutekiNetOfNotice: string,
        receivingAgencyCd: string,
        isOwnershipTransfer: boolean
    }
    dIspStepInfo: DIspStepInfo
}

interface FieldsError {
    familyName: Error[]
    firstName: Error[]
    familyNameKana: Error[]
    firstNameKana: Error[]
    birthday: Error[]
    birthdayYear: Error[]
    birthdayMonth: Error[]
    birthdayDay: Error[]
    sex: Error[]
    password: Error[]
    passwordConfirm: Error[]
}

interface Error {
    message: string
    resultCode: string
    hasError: boolean
}

type Field =
    'familyName'
    | 'firstName'
    | 'familyNameKana'
    | 'firstNameKana'
    | 'birthday'
    | 'birthdayYear'
    | 'birthdayMonth'
    | 'birthdayDay'
    | 'sex'
    | 'password'
    | 'passwordConfirm';

type inputOrSelectState =
    'familyName'
    | 'firstName'
    | 'familyNameKana'
    | 'firstNameKana'
    | 'birthdayYear'
    | 'birthdayMonth'
    | 'birthdayDay'
    | 'sex'
    | 'wishToHasekoGroupInfos'
    | 'sutekiNetOfNotice'
    | 'password'
    | 'passwordConfirm';

interface Props {
    residentUserRepo: NatResidentUserRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    tokenRepo: NatTokenRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    ownershipTransfersRepo: NatOwnershipTransfersRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    dIspStepInfo: DIspStepInfo,
    nowStep: Step
    residentUserType: string
    token: NatGetToken
    condominiumData: NatGetRoomToResidentAuthenticationKey | NatGetToken
    confirmButtonFlg: boolean
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    birthday: string,
    birthdayYear: string,
    birthdayMonth: string,
    birthdayDay: string,
    sex: string,
    password: string,
    passwordConfirm: string,
    dispPassword: string,
    currentYearMonth: number,
    wishToHasekoGroupInfos: string,
    sutekiNetOfNotice: string,
    wishToHasekoGroupInfosDispFlg: boolean,
    receivingAgencyCd: string,
    fieldsError: Partial<FieldsError>,
    isLoadCompleted: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

const MIN_BIRTHDAY_SELECTABLE_YEAR: number = 1900
const MIN_BIRTHDAY_SELECTABLE_MONTH: number = 1
const MAX_BIRTHDAY_SELECTABLE_MONTH: number = 12
const MIN_BIRTHDAY_SELECTABLE_DAY: number = 1
const MAX_BIRTHDAY_SELECTABLE_DAY: number = 31

const PASSWORD_LABEL = 'パスワード'
const PASSWORD_CONFIRM_LABEL = 'パスワード（確認用）'

class NatResidentFirstLoginUserInfoInputPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState
    queryToken: string
    isOwnershipTransfer: boolean
    autoFocus: RefObject<HTMLInputElement>
    systemErrorMessageId: string

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            dIspStepInfo: {},
            nowStep: Step.USER_REGISTER,
            residentUserType: '',
            token: {
                details: {
                    token: '',
                    sutekiNetId: '',
                    mailAddress: '',
                    authenticationKey: '',
                    parentResidentId: '',
                    policyAgreeType: '',
                    referenceId: '',
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    familyNameKana: '',
                    firstNameKana: '',
                    freeSettingItem: '',
                    flpExistFlag: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            condominiumData: {
                details: {
                    token: '',
                    sutekiNetId: '',
                    mailAddress: '',
                    authenticationKey: '',
                    parentResidentId: '',
                    policyAgreeType: '',
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    receivingAgencyCd: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            confirmButtonFlg: true,
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            birthday: '',
            birthdayYear: '',
            birthdayMonth: '',
            birthdayDay: '',
            sex: SEX_MASTER.UNKNOWN.value,
            password: '',
            passwordConfirm: '',
            dispPassword: VALID_OR_NOT.NOT.value,
            currentYearMonth: 0,
            wishToHasekoGroupInfos: DO_OR_NOT.DO.value,
            sutekiNetOfNotice: DO_OR_NOT.DO.value,
            wishToHasekoGroupInfosDispFlg: true,
            receivingAgencyCd: '',
            fieldsError: {},
            isLoadCompleted: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }
        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : {}
        this.queryToken = getQueryParameter('token', this.props.location.search)
        this.autoFocus = React.createRef()
        this.isOwnershipTransfer = new URLSearchParams(this.props.location.search).has('ownershipTransfer')
        this.systemErrorMessageId =
            this.isOwnershipTransfer ? Messages.ERESR0013.toString() : Messages.ERESR0003.toString()

        this.systemErrorTransition = this.systemErrorTransition.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handlePassworDispTypeChange = this.handlePassworDispTypeChange.bind(this)
        this.confirmButtonClick = this.confirmButtonClick.bind(this)
        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
        this.onChangeFamilyName = this.onChangeFamilyName.bind(this)
        this.onChangeFirstName = this.onChangeFirstName.bind(this)
        this.onChangeFamilyNameKana = this.onChangeFamilyNameKana.bind(this)
        this.onChangeFirstNameKana = this.onChangeFirstNameKana.bind(this)
        this.onChangeBirthdayYear = this.onChangeBirthdayYear.bind(this)
        this.onChangeBirthdayMonth = this.onChangeBirthdayMonth.bind(this)
        this.onChangeBirthdayDay = this.onChangeBirthdayDay.bind(this)
        this.onChangeSelectSex = this.onChangeSelectSex.bind(this)
        this.onChangeWishToHasekoGroupInfos = this.onChangeWishToHasekoGroupInfos.bind(this)
        this.onChangeSutekiNetOfNotice = this.onChangeSutekiNetOfNotice.bind(this)
        this.onChangePassword = this.onChangePassword.bind(this)
        this.onChangePasswordConfirm = this.onChangePasswordConfirm.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        // 遷移元画面ID　取得
        const firstLoginReferrerId: string = (Object.keys(this.firstLoginLocationState).length) ?
            this.firstLoginLocationState.firstLoginReferrerId : ''

        // 居住者ユーザタイプ
        let residentUserType: string
        if (Object.keys(this.firstLoginLocationState).length &&
            this.firstLoginLocationState.firstLoginUserInfoInput &&
            this.firstLoginLocationState.firstLoginUserInfoInput.residentUserType) {
            // history が存在する場合
            residentUserType = this.firstLoginLocationState.firstLoginUserInfoInput.residentUserType
        } else if (firstLoginReferrerId === '') {
            // 遷移元が存在しない場合
            residentUserType = RESIDENT_USER_TYPE.MAIN.value
        } else {
            // 遷移元が存在する場合
            residentUserType = this.firstLoginLocationState.residentUserType
        }

        if (this.queryToken === '') {
            if (residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
                // メインユーザ
                this.props.navigate('/resident/error', {
                    state: {
                        message: this.systemErrorMessageId,
                        nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                    },
                })
                return
            } else {
                // サブユーザ
                this.props.navigate('/resident/error', {state: {message: Messages.ERESR0004.toString()}})
                return
            }
        }

        // トークン取得
        await this.props.eventEmitter.showLoading()
        try {
            const retToken: Nullable<NatGetToken> =
                await NatAsyncCallFunction(this.props.tokenRepo.getToken.bind(
                    this.props.tokenRepo, this.queryToken), this.props.navigate, this.systemErrorTransition)

            if (retToken === null) {
                return
            }

            // トークンチェック
            if (firstLoginReferrerId !== FIRST_LOGIN_REFERRER_ID.POLICY_AGREE.value &&
                retToken && retToken.details === null) {
                if (residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
                    this.props.navigate('/resident/error', {
                        state: {
                            message: this.systemErrorMessageId,
                            nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                        },
                    })
                    return
                } else {
                    // サブユーザ
                    this.props.navigate('/resident/error', {state: {message: Messages.ERESR0004.toString()}})
                    return
                }
            }

            if (retToken.details === null) {
                return
            }

            let condominiumData: Nullable<NatGetRoomToResidentAuthenticationKey> | NatGetToken
            let step: DIspStepInfo = {}
            let nowStep: Step
            let receivingAgencyCd = ''
            if (residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
                // メインユーザの場合
                const authenticationKey: string = retToken.details.authenticationKey
                // 物件情報取得
                condominiumData = await NatAsyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                        this.props.roomToResidentRepo, authenticationKey),
                    this.props.navigate, this.systemErrorTransition,
                )

                if (condominiumData && condominiumData.details) {
                    receivingAgencyCd = condominiumData.details.receivingAgencyCd
                }

                // STEP
                step = this.firstLoginLocationState.dIspStepInfo ??
                    {
                        userRegister: true,
                        userConfirm: true,
                        complete: true,
                    }
                nowStep = Step.USER_REGISTER
            } else {
                // サブユーザの場合
                condominiumData = retToken
                // STEP
                step = this.firstLoginLocationState.dIspStepInfo
                nowStep = Step.SUB_USER_REGISTER

            }

            // 規約同意タイプ
            let policyAgreeType: string = ''
            if (!this.firstLoginLocationState.firstLoginReferrerId) {
                // メールから遷移した場合
                policyAgreeType = retToken.details.policyAgreeType
            } else {
                policyAgreeType = this.firstLoginLocationState.policyAgreeType
            }

            // ブランシエラクラブ 表示判定
            let wishToHasekoGroupInfosDispFlg: boolean
            wishToHasekoGroupInfosDispFlg = policyAgreeType === AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value

            const currentDateTime: Nullable<NatGetCurrentDateTime> =
                await NatAsyncCallFunction(
                    this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                        this.props.currentDateTimeRepo), this.props.navigate, this.systemErrorTransition)

            if (condominiumData &&
                currentDateTime && currentDateTime.details
            ) {
                const currentYearMonth: number = getCurrentYear(`${currentDateTime.details.currentDateTime}+09:00`)
                this.setState({
                    residentUserType: residentUserType,
                    token: retToken,
                    condominiumData: condominiumData,
                    dIspStepInfo: step,
                    nowStep: nowStep,
                    familyName: retToken.details.familyName,
                    firstName: retToken.details.firstName,
                    familyNameKana: retToken.details.familyNameKana,
                    firstNameKana: retToken.details.firstNameKana,
                    wishToHasekoGroupInfos: (wishToHasekoGroupInfosDispFlg) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value,
                    wishToHasekoGroupInfosDispFlg: wishToHasekoGroupInfosDispFlg,
                    currentYearMonth: currentYearMonth,
                    receivingAgencyCd: receivingAgencyCd,
                })
            }

            // フォーム初期値設定
            this.defaultInputData()

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})

        }

        if (this.autoFocus.current) {
            this.autoFocus.current.focus()
            window.scrollTo(0, 0)
        }
    }

    // フォーム初期値設定
    defaultInputData(): void {
        // 　入力情報が存在する場合
        if (this.firstLoginLocationState &&
            this.firstLoginLocationState.firstLoginUserInfoInput) {
            const familyName: string = this.firstLoginLocationState.firstLoginUserInfoInput.familyName
            const firstName: string = this.firstLoginLocationState.firstLoginUserInfoInput.firstName
            const familyNameKana: string = this.firstLoginLocationState.firstLoginUserInfoInput.familyNameKana
            const firstNameKana: string = this.firstLoginLocationState.firstLoginUserInfoInput.firstNameKana
            const birthday: string[] = this.firstLoginLocationState.firstLoginUserInfoInput.birthday.split('-')
            const sex: string = this.firstLoginLocationState.firstLoginUserInfoInput.sex
            const wishToHasekoGroupInfos: string =
                this.firstLoginLocationState.firstLoginUserInfoInput.wishToHasekoGroupInfos
            const wishToHasekoGroupInfosDispFlg: boolean =
                this.firstLoginLocationState.firstLoginUserInfoInput.wishToHasekoGroupInfosDispFlg
            const {sutekiNetOfNotice} = this.firstLoginLocationState.firstLoginUserInfoInput

            this.setState({
                familyName: familyName,
                firstName: firstName,
                familyNameKana: familyNameKana,
                firstNameKana: firstNameKana,
                birthdayYear: birthday[0],
                birthdayMonth: birthday[1],
                birthdayDay: birthday[2],
                sex: sex,
                wishToHasekoGroupInfos: wishToHasekoGroupInfos,
                wishToHasekoGroupInfosDispFlg: wishToHasekoGroupInfosDispFlg,
                sutekiNetOfNotice: sutekiNetOfNotice,
            })
        }
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKana ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKana ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    onChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('familyName', event.target.value)
    }

    onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('firstName', event.target.value)
    }

    onChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('familyNameKana', event.target.value)
    }

    onChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('firstNameKana', event.target.value)
    }

    onChangeBirthdayYear(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setInputOrSelectState('birthdayYear', event.target.value)
    }

    onChangeBirthdayMonth(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setInputOrSelectState('birthdayMonth', event.target.value)
    }

    onChangeBirthdayDay(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setInputOrSelectState('birthdayDay', event.target.value)
    }

    onChangeSelectSex(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('sex', event.target.value)
    }

    onChangeWishToHasekoGroupInfos(event: React.ChangeEvent<HTMLInputElement>): void {
        const checked = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
        this.setInputOrSelectState('wishToHasekoGroupInfos', checked)
    }

    onChangeSutekiNetOfNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        const checked = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
        this.setInputOrSelectState('sutekiNetOfNotice', checked)
    }

    onChangePassword(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('password', event.target.value)
    }

    onChangePasswordConfirm(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('passwordConfirm', event.target.value)
    }


    setInputOrSelectState(
        inputOrSelectStateKey: inputOrSelectState,
        inputOrSelectStateValue: string,
    ): void {
        const inputOrSelectData: { [key: string]: string; } = {}
        inputOrSelectData.familyName = this.state.familyName
        inputOrSelectData.firstName = this.state.firstName
        inputOrSelectData.familyNameKana = this.state.familyNameKana
        inputOrSelectData.firstNameKana = this.state.firstNameKana
        inputOrSelectData.birthdayYear = this.state.birthdayYear
        inputOrSelectData.birthdayMonth = this.state.birthdayMonth
        inputOrSelectData.birthdayDay = this.state.birthdayDay
        inputOrSelectData.sex = this.state.sex
        inputOrSelectData.wishToHasekoGroupInfos = this.state.wishToHasekoGroupInfos
        inputOrSelectData.sutekiNetOfNotice = this.state.sutekiNetOfNotice
        inputOrSelectData.password = this.state.password
        inputOrSelectData.passwordConfirm = this.state.passwordConfirm

        // パラメータで上書き
        inputOrSelectData[inputOrSelectStateKey] = inputOrSelectStateValue

        // フリガナ設定
        switch (inputOrSelectStateKey) {
            case 'familyName':
                inputOrSelectData.familyNameKana = inputOrSelectStateValue ? this.state.convertFamilyNameKana : ''
                break
            case 'firstName':
                inputOrSelectData.firstNameKana = inputOrSelectStateValue ? this.state.convertFirstNameKana : ''
                break
            default:
                break
        }

        const confirmButtonFlg: boolean = !(inputOrSelectData.familyName !== '' &&
            inputOrSelectData.firstName !== '' &&
            inputOrSelectData.familyNameKana !== '' &&
            inputOrSelectData.firstNameKana !== '' &&
            inputOrSelectData.birthdayYear !== '' &&
            inputOrSelectData.birthdayMonth !== '' &&
            inputOrSelectData.birthdayDay !== '' &&
            inputOrSelectData.sex !== '' &&
            inputOrSelectData.password !== '' &&
            inputOrSelectData.passwordConfirm !== '')

        this.setState({
            familyName: inputOrSelectData.familyName,
            firstName: inputOrSelectData.firstName,
            familyNameKana: inputOrSelectData.familyNameKana,
            firstNameKana: inputOrSelectData.firstNameKana,
            birthdayYear: inputOrSelectData.birthdayYear,
            birthdayMonth: inputOrSelectData.birthdayMonth,
            birthdayDay: inputOrSelectData.birthdayDay,
            sex: inputOrSelectData.sex,
            wishToHasekoGroupInfos: inputOrSelectData.wishToHasekoGroupInfos,
            sutekiNetOfNotice: inputOrSelectData.sutekiNetOfNotice,
            password: inputOrSelectData.password,
            passwordConfirm: inputOrSelectData.passwordConfirm,
            confirmButtonFlg: confirmButtonFlg,
        })
    }

    // ブランシエラクラブ
    renderMailMagazineDeliveryHope(): ReactElement {
        return (
            <>
                <Box>メールマガジン配信希望</Box>
                <Box height={'5px'}/>
                <InfosWhiteArea>
                    <Box height={'10px'}/>
                    {this.state.wishToHasekoGroupInfosDispFlg &&
                        <Box>
                            <LeftRowFlexContainer>
                                <Checkbox
                                    name="wishToHasekoGroupInfos"
                                    color="default"
                                    checked={(this.state.wishToHasekoGroupInfos !== DO_OR_NOT.NOT.value)}
                                    onChange={this.onChangeWishToHasekoGroupInfos}
                                />
                                長谷工グループ「ブランシエラクラブ」
                            </LeftRowFlexContainer>
                            <InfosContainer>
                                長谷工グループからのお得情報、住まいに関する情報をお届けいたします。（特典、住まいレージポイントサービス、イベント、その他お得なお知らせなど）
                            </InfosContainer>
                            <Box height={'5px'}/>
                        </Box>
                    }
                    <Box>
                        <LeftRowFlexContainer>
                            <Checkbox
                                name="sutekiNetOfNotice"
                                color="default"
                                checked={(this.state.sutekiNetOfNotice !== DO_OR_NOT.NOT.value)}
                                onChange={this.onChangeSutekiNetOfNotice}
                            />
                            すてきテラス
                        </LeftRowFlexContainer>
                        <InfosContainer>
                            「すてきテラス」よりマンションに関するサービスのご紹介や暮らしに役立つ情報などを定期的にお届けいたします。
                        </InfosContainer>
                    </Box>
                    <BlockSpacer height={'15px'}/>
                    <Box padding={'0 9px'} fontSize={FontSize.Small} color={Colors.AccentDark}>
                        ※メールマガジン内のリンクよりいつでも配信停止できます。
                    </Box>
                    <BlockSpacer height={'15px'}/>
                </InfosWhiteArea>
            </>
        )
    }

    renderYearSelect(): Nullable<ReactNode> {
        const yearList: OptionProps[] = []
        for (let year: number = this.state.currentYearMonth; MIN_BIRTHDAY_SELECTABLE_YEAR <= year; year--) {
            yearList.push({
                label: `${year}`,
                value: `${year}`,
            })
        }
        const yearOptions = [{
            label: '',
            value: '',
        }, ...yearList]

        return (
            <BirthdaySelectIcon>
                <BirthdaySelect
                    onChange={this.onChangeBirthdayYear}
                    hasError={(this.getFieldErrorStatus('birthday') || this.getFieldErrorStatus('birthdayYear'))}
                    value={this.state.birthdayYear}>
                    {yearOptions.map((category, key) => {
                        return (
                            <option key={key} value={category.value}>
                                {category.label}
                            </option>
                        )
                    })}
                </BirthdaySelect>
            </BirthdaySelectIcon>
        )
    }

    renderMonthSelect(): ReactNode {
        const monthList: OptionProps[] = []

        for (let month: number = MIN_BIRTHDAY_SELECTABLE_MONTH; month <= MAX_BIRTHDAY_SELECTABLE_MONTH; month++) {
            monthList.push({
                label: `${month}`,
                value: (String(month).length === 1) ? '0' + String(month) : String(month),
            })
        }
        const monthOptions = [{
            label: '',
            value: '',
        }, ...monthList]
        return (
            <BirthdaySelectIcon>
                <BirthdaySelect
                    onChange={this.onChangeBirthdayMonth}
                    hasError={(this.getFieldErrorStatus('birthday') || this.getFieldErrorStatus('birthdayMonth'))}
                    value={this.state.birthdayMonth}>

                    {monthOptions.map((category, index) => {
                        return (
                            <option value={category.value} key={index}>
                                {category.label}</option>
                        )
                    })}
                </BirthdaySelect>
            </BirthdaySelectIcon>
        )
    }

    renderDaySelect(): ReactNode {
        const dayList: OptionProps[] = []

        for (let day: number = MIN_BIRTHDAY_SELECTABLE_DAY; day <= MAX_BIRTHDAY_SELECTABLE_DAY; day++) {
            dayList.push({
                label: `${day}`,
                value: (String(day).length === 1) ? '0' + String(day) : String(day),
            })
        }
        const dayOptions = [{
            label: '',
            value: '',
        }, ...dayList]
        return (
            <BirthdaySelectIcon>
                <BirthdaySelect
                    onChange={this.onChangeBirthdayDay}
                    hasError={(this.getFieldErrorStatus('birthday') || this.getFieldErrorStatus('birthdayDay'))}
                    value={this.state.birthdayDay}>
                    {dayOptions.map((category, index) => {
                        return (
                            <option value={category.value} key={index}>
                                {category.label}</option>
                        )
                    })}
                </BirthdaySelect>
            </BirthdaySelectIcon>
        )
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`, {
            state: {
                message: Messages.ESYCC0018.toString(),
                nonDisplayBackBtnFlag: this.isOwnershipTransfer,
            },
        })
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        let familyName: string = this.state.familyName
        let firstName: string = this.state.firstName
        let familyNameKana: string = this.state.familyNameKana
        let firstNameKana: string = this.state.firstNameKana
        let birthday: string = this.state.birthday
        let sex: string = this.state.sex
        let wishToHasekoGroupInfos: string = this.state.wishToHasekoGroupInfos
        let password: string = this.state.password
        let passwordConfirm: string = this.state.passwordConfirm
        let confirmButtonFlg: boolean

        // 入力項目
        switch (event.target.name) {
            case 'familyName':
                familyName = event.target.value
                familyNameKana = this.state.convertFamilyNameKana
                break
            case 'firstName':
                firstName = event.target.value
                firstNameKana = this.state.convertFirstNameKana
                break
            case 'familyNameKana':
                familyNameKana = event.target.value
                break
            case 'firstNameKana':
                firstNameKana = event.target.value
                break
            case 'birthday':
                birthday = event.target.value
                break
            case 'sex':
                sex = event.target.value
                break
            case 'wishToHasekoGroupInfos':
                wishToHasekoGroupInfos = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
                break
            case 'password':
                password = event.target.value
                break
            case 'passwordConfirm':
                passwordConfirm = event.target.value
                break
            default:
                break
        }

        // 活性/非活性　制御
        confirmButtonFlg = familyName === '' ||
            firstName === '' ||
            familyNameKana === '' ||
            firstNameKana === '' ||
            birthday === '' ||
            sex === '' ||
            password === '' ||
            passwordConfirm === ''

        this.setState({
            familyName: familyName,
            firstName: firstName,
            familyNameKana: familyNameKana,
            firstNameKana: firstNameKana,
            birthday: birthday,
            sex: sex,
            wishToHasekoGroupInfos: wishToHasekoGroupInfos,
            password: password,
            passwordConfirm: passwordConfirm,
            confirmButtonFlg: confirmButtonFlg,
        })
    }

    // パスワードを表示する
    handlePassworDispTypeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.checked) {
            this.setState({dispPassword: VALID_OR_NOT.VALID.value})
        } else {
            this.setState({dispPassword: VALID_OR_NOT.NOT.value})
        }
    }

    // 入力内容を確認する
    async confirmButtonClick(): Promise<void> {
        await this.clearMessage()

        // 相関チェック
        if (this.state.password !== this.state.passwordConfirm) {
            await this.clearMessage()
            this.setFieldErrorMessage(
                'passwordConfirm',
                Messages.EOPCC0019.toString(PASSWORD_LABEL, PASSWORD_CONFIRM_LABEL),
                '',
            )
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            // 居住者ユーザ登録確認
            const request: ResidentUserConfirmRequest = {
                familyName: this.state.familyName,
                firstName: this.state.firstName,
                familyNameKana: this.state.familyNameKana,
                firstNameKana: this.state.firstNameKana,
                birthdayYear: this.state.birthdayYear,
                birthdayMonth: this.state.birthdayMonth,
                birthdayDay: this.state.birthdayDay,
                sex: this.state.sex,
                password: this.state.password,
                wishToHasekoGroupInfos: this.state.wishToHasekoGroupInfos,
                sutekiNetOfNotice: this.state.sutekiNetOfNotice,
            }
            const ret: Nullable<NatPostResidentUserConfirm> =
                await NatAsyncCallFunction(this.props.residentUserRepo.residentUserConfirm.bind(
                    this.props.residentUserRepo, request), this.props.navigate, this.systemErrorTransition)

            if (!ret) {
                return
            }

            if (this.state.token.details === null ||
                this.state.condominiumData.details === null) {
                return
            }

            // 規約同意タイプ
            let policyAgreeType: string
            if (this.state.residentUserType === RESIDENT_USER_TYPE.MAIN.value) {
                // メインユーザの場合、トークンから取得
                policyAgreeType = this.state.token.details.policyAgreeType
            } else {
                // サブユーザの場合、引継ぎ情報から取得
                policyAgreeType = this.firstLoginLocationState.policyAgreeType
            }

            // 引継ぎ情報
            this.firstLoginLocationState.firstLoginReferrerId = FIRST_LOGIN_REFERRER_ID.USER_INFO_INPUT.value
            this.firstLoginLocationState.policyAgreeType = policyAgreeType
            this.firstLoginLocationState.authenticationKey = this.state.token.details.authenticationKey
            this.firstLoginLocationState.firstLoginUserInfoInput = {
                parentResidentId: this.state.condominiumData.details.parentResidentId,
                residentUserType: this.state.residentUserType,
                condominiumCd: this.state.condominiumData.details.condominiumCd,
                condominiumName: this.state.condominiumData.details.condominiumName,
                ridgeName: this.state.condominiumData.details.ridgeName,
                roomNumber: this.state.condominiumData.details.roomNumber,
                policyAgreeType: this.firstLoginLocationState.policyAgreeType,
                familyName: this.state.familyName,
                firstName: this.state.firstName,
                familyNameKana: this.state.familyNameKana,
                firstNameKana: this.state.firstNameKana,
                sex: this.state.sex,
                mailAddress: this.state.token.details.mailAddress,
                birthday: `${this.state.birthdayYear}-${this.state.birthdayMonth}-${this.state.birthdayDay}`,
                password: this.state.password,
                wishToHasekoGroupInfos: this.state.wishToHasekoGroupInfos,
                wishToHasekoGroupInfosDispFlg: this.state.wishToHasekoGroupInfosDispFlg,
                sutekiNetOfNotice: this.state.sutekiNetOfNotice,
                receivingAgencyCd: this.state.receivingAgencyCd,
                isOwnershipTransfer: this.isOwnershipTransfer,
            }
            this.firstLoginLocationState.dIspStepInfo = this.state.dIspStepInfo

            this.props.navigate(
                `/resident/firstLoginUserInfoConfirm?token=${this.queryToken}`,
                {state: {firstLoginLocationState: this.firstLoginLocationState}},
            )

        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        item.fields.forEach((field) => {
                            this.setFieldErrorMessage(field, item.message, item.resultCode)
                            {
                            }
                        })
                    }
                    if (item.resultCode === 'birthday') {
                        this.setFieldErrorMessage('birthday', item.message, item.resultCode)
                    }
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(
            this.isOwnershipTransfer && this.state.token.details?.referenceId
                ? `/guest/mypage?accessKey=${this.state.token.details.referenceId}`
                : `/resident/login`,
        )
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string, resultCode: string): void {
        if (field === 'familyName' || field === 'firstName' || field === 'familyNameKana' ||
            field === 'firstNameKana' || field === 'birthday' || field === 'birthdayYear' ||
            field === 'birthdayMonth' || field === 'birthdayDay' || field === 'sex' ||
            field === 'password' || field === 'passwordConfirm') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, resultCode: resultCode, hasError: true}]
            } else {
                error.push({message: message, resultCode: resultCode, hasError: true})
            }
            ReactDOM.flushSync(() => {
                this.setState(({fieldsError}) => (
                    {
                        fieldsError: {
                            ...fieldsError,
                            [field]: error,
                        },
                    }))
            })
        }
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <>
                    {field.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }
    }

    // メッセージ取得（生年月日フィールド）
    getBirthDayFieldErrorMessage(): Nullable<ReactElement> {
        const birthday: Error[] | undefined = this.state.fieldsError.birthday
        const birthdayYear: Error[] | undefined = this.state.fieldsError.birthdayYear
        const birthdayMonth: Error[] | undefined = this.state.fieldsError.birthdayMonth
        const birthdayDay: Error[] | undefined = this.state.fieldsError.birthdayDay
        let required: Error[] | undefined = []

        let requiredCount: number = 0

        if (birthdayYear !== undefined) {
            required = birthdayYear
            birthdayYear.map((error) => {
                if (error.resultCode === 'Required') {
                    requiredCount += 1
                }
            })
        }

        if (birthdayMonth !== undefined) {
            required = birthdayMonth
            birthdayMonth.map((error) => {
                if (error.resultCode === 'Required') {
                    requiredCount += 1
                }
            })
        }

        if (birthdayDay !== undefined) {
            required = birthdayDay
            birthdayDay.map((error) => {
                if (error.resultCode === 'Required') {
                    requiredCount += 1
                }
            })
        }


        if (requiredCount > 0 && required !== undefined) {
            return (
                <>
                    {required.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else if (birthday !== undefined) {
            return (
                <>
                    {birthday.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }


    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field[0] !== undefined && field[0].hasError)
    }


    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {passwordConfirm: []}})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        if (this.state.token.details !== null &&
            this.state.condominiumData.details !== null) {
            return (
                <>
                    <NatStepComponent
                        dIspStepInfo={this.state.dIspStepInfo}
                        nowStep={this.state.nowStep}
                    />
                    <ContentsSubTitleWrapper>
                        <ContentsSubTitleInner>
                            ユーザ情報登録
                        </ContentsSubTitleInner>
                    </ContentsSubTitleWrapper>
                    <WideMainContainer>
                        <BlockSpacer height={'15px'}/>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabel>マンション名</DisplayItemInputLabel>
                            <DisplayItemDiv>{this.state.condominiumData.details.condominiumName}</DisplayItemDiv>
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabel>部屋番号</DisplayItemInputLabel>
                            {/* tslint:disable-next-line:max-line-length */}
                            <DisplayItemDiv>{this.state.condominiumData.details.ridgeName}{convertToRoomNumberForResident(this.state.condominiumData.details.roomNumber)}</DisplayItemDiv>
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>氏名</DisplayItemInputTitleRequired>
                            </DisplayItemInputLabelRequired>
                            <BlockFormDetail>
                                <InputLabel>姓</InputLabel>
                                <DisplayItemDetailsInput
                                    type="text"
                                    id="familyName"
                                    name="familyName"
                                    maxLength={10}
                                    value={this.state.familyName}
                                    onInput={this.onChangeFamilyName}
                                    onChange={this.onChangeFamilyName}
                                    onCompositionStart={this.onCompositionStartFamilyName}
                                    onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                    hasError={this.getFieldErrorStatus('familyName')}
                                    ref={this.autoFocus}
                                />
                            </BlockFormDetail>
                            {this.getFieldErrorMessage('familyName')}
                            <BlockFormDetail>
                                <InputLabel>名</InputLabel>
                                <DisplayItemDetailsInput
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    maxLength={10}
                                    value={this.state.firstName}
                                    onInput={this.onChangeFirstName}
                                    onChange={this.onChangeFirstName}
                                    onCompositionStart={this.onCompositionStartFirstName}
                                    onCompositionUpdate={this.onCompositionUpdateFirstName}
                                    hasError={this.getFieldErrorStatus('firstName')}
                                />
                            </BlockFormDetail>
                            {this.getFieldErrorMessage('firstName')}
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>フリガナ</DisplayItemInputTitleRequired>
                            </DisplayItemInputLabelRequired>
                            <BlockFormDetail>
                                <InputLabel>セイ</InputLabel>
                                <DisplayItemDetailsInput
                                    type="text"
                                    id="familyNameKana"
                                    name="familyNameKana"
                                    value={this.state.familyNameKana}
                                    maxLength={20}
                                    onInput={this.onChangeFamilyNameKana}
                                    onChange={this.onChangeFamilyNameKana}
                                    hasError={this.getFieldErrorStatus('familyNameKana')}
                                />
                            </BlockFormDetail>
                            {this.getFieldErrorMessage('familyNameKana')}
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <BlockFormDetail>
                                <InputLabel>メイ</InputLabel>
                                <DisplayItemDetailsInput
                                    type="text"
                                    id="firstNameKana"
                                    name="firstNameKana"
                                    value={this.state.firstNameKana}
                                    maxLength={20}
                                    onInput={this.onChangeFirstNameKana}
                                    onChange={this.onChangeFirstNameKana}
                                    hasError={this.getFieldErrorStatus('firstNameKana')}
                                />
                            </BlockFormDetail>
                            {this.getFieldErrorMessage('firstNameKana')}
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabel>メールアドレス</DisplayItemInputLabel>
                            <DisplayItemDiv>{this.state.token.details.mailAddress}</DisplayItemDiv>
                        </DisplayBlockDiv>

                        <DisplayBlockDiv>
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>生年月日</DisplayItemInputTitleRequired>
                            </DisplayItemInputLabelRequired>
                            {this.renderYearSelect()}<SelectTxt>年</SelectTxt>
                            {this.renderMonthSelect()}<SelectTxt>月</SelectTxt>
                            {this.renderDaySelect()}<SelectTxt>日</SelectTxt>
                            {this.getBirthDayFieldErrorMessage()}
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>性別</DisplayItemInputTitleRequired>
                                {SEX_MASTER.values().map((sexMaster, index) => (
                                    <DisplayRadioItemLabel key={index}>
                                        <DisplayRadioItemName>
                                            <input type="radio"
                                                   name={'sex'}
                                                   value={sexMaster.value}
                                                   checked={(sexMaster.value === this.state.sex)}
                                                   onChange={this.onChangeSelectSex}/>
                                            {sexMaster.label}
                                        </DisplayRadioItemName>
                                    </DisplayRadioItemLabel>

                                ))}
                            </DisplayItemInputLabelRequired>
                            {this.getFieldErrorMessage('sex')}
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>{PASSWORD_LABEL}</DisplayItemInputTitleRequired>
                                <DisplayItemInput
                                    type={(this.state.dispPassword === VALID_OR_NOT.NOT.value) ? 'password' : 'text'}
                                    autoComplete={'new-password'}
                                    name="password"
                                    maxLength={16}
                                    onInput={this.onChangePassword}
                                    onChange={this.onChangePassword}
                                    hasError={this.getFieldErrorStatus('password')}
                                />
                                <Note>{Messages.IRESR0005.toString('')}</Note>
                            </DisplayItemInputLabelRequired>
                            {this.getFieldErrorMessage('password')}
                        </DisplayBlockDiv>
                        <DisplayBlockDiv>
                            <DisplayItemInputLabelRequired>
                                <DisplayItemInputTitleRequired>{PASSWORD_CONFIRM_LABEL}</DisplayItemInputTitleRequired>
                                <DisplayItemInput
                                    type={(this.state.dispPassword === VALID_OR_NOT.NOT.value) ? 'password' : 'text'}
                                    autoComplete={'new-password'}
                                    name="passwordConfirm"
                                    maxLength={16}
                                    onInput={this.onChangePasswordConfirm}
                                    onChange={this.onChangePasswordConfirm}
                                    hasError={this.getFieldErrorStatus('passwordConfirm')}
                                />
                                <DisplayCheckItemSelectionLabel>
                                    <DisplayCheckItemSelectionName>
                                        <input type="checkbox"
                                               value={this.state.dispPassword}
                                               onChange={this.handlePassworDispTypeChange}/>
                                        パスワードを表示する
                                    </DisplayCheckItemSelectionName>
                                </DisplayCheckItemSelectionLabel>
                            </DisplayItemInputLabelRequired>
                            {this.getFieldErrorMessage('passwordConfirm')}
                        </DisplayBlockDiv>
                        <BlockSpacer height={'5px'}/>
                    </WideMainContainer>
                    <BlockSpacer height={'20px'}/>
                    {this.renderMailMagazineDeliveryHope()}
                    <BlockSpacer height={'30px'}/>
                    <PrimaryStyledButton
                        onClick={this.confirmButtonClick}
                        disabled={this.state.confirmButtonFlg}>
                        入力内容を確認する
                    </PrimaryStyledButton>
                    <BlockSpacer height={'30px'}/>
                    <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick}>
                        {this.isOwnershipTransfer ? 'トップページへ戻る' : 'ログイン画面へ戻る'}
                    </CenterPlainLinkStyledButton>
                    <BlockSpacer height={'30px'}/>
                </>
            )
        } else {
            return null
        }
    }
}

export default createResidentPage(NatResidentFirstLoginUserInfoInputPage)

// フォームブロック
const BlockFormDetail: StyledDiv = styled.div`
  display: table;
  margin-bottom: 10px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`

// フォームラベル
const InputLabel: StyledDiv = styled.div`
  display: table-cell;
  width: 50px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: 0 0 0 1px ${Colors.AccentLight} inset;
  text-align: center;
  border-right: none;
  background-color: ${Colors.Background};
  vertical-align: middle;
  font-size: ${FontSize.Small};
`

// 入力フォーム
const DisplayItemDetailsInput = styled(DisplayItemInput)`
  border-radius: 0 4px 4px 0;
  vertical-align: top;
`

const InfosWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 7px;
  box-sizing: border-box;
  overflow: hidden;
`

// 長谷工グループ希望
const InfosContainer: StyledDiv = styled.div`
  padding: 0 15px 0 33px;
  font-size: ${FontSize.Middle};
`

const BirthdaySelect = styled(DisplayItemSelect)`
  width: 100%;
`
const BirthdaySelectIcon = styled(DisplayItemSelectIcon)`
  display: inline-block;

  &:after {
    right: 5%;
  }
`

const SelectTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`
